<template>
  <div class="threepage aw-swiper">
    <div
      ref="slideCarousel"
      class="carousel-container aw-swiper__container"
    >
      <div class="swiper-wrapper">
        <div
          v-for="item in imgUrls"
          :key="item.index"
          class="swiper-slide aw-swiper__slide"
          :class="`aw-swiper__slide--${item.type}`"
          @click="handleSlideClick(item)"
        >
          <img class="aw-swiper__image" :src="preText + getImageByDevice(item)" />
        </div>
      </div>
    </div>
    <div ref="pagination" class="swiper-pagination-kv2 aw-swiper__pagination"></div>
    <PopVideo :visible.sync="isShowVideo" :video-url="fullVideoUrl" />
  </div>
</template>

<script>
import { isPortraitFun } from "@/utils/utils.js";
import PopVideo from "@/components/aw2025/pop-video";
import {
  buildSwiperGroupImages,
  createSwiperInstance,
  destroySwiperInstance,
  getKiaBaseUrl,
  getMobileLoopAutoplayOptions,
} from "@/components/aw2025/swiper-common";

export default {
  components: { PopVideo },
  data() {
    const bookedVideoConfig = {
      1: "https://img.kia.cn/media/videos/202604/suchao-1-20260429.mp4",
      2: "https://img.kia.cn/media/videos/202604/suchao-2-20260429.mp4",
    };
    const rawSlides = buildSwiperGroupImages(1, 2, 2, bookedVideoConfig);
    return {
      isPortrait: isPortraitFun(),
      preText: "https://www.kia.cn",
      swiper: null,
      imgUrls: rawSlides,
      isShowVideo: false,
      fullVideoUrl: "",
    };
  },
  mounted() {
    this.preText = getKiaBaseUrl();
    window.addEventListener("resize", this.setResize);

    this.$nextTick(() => {
      this.swiper = createSwiperInstance(
        this.$refs.slideCarousel,
        getMobileLoopAutoplayOptions({
          slidesPerView: "auto",
          centeredSlides: !this.isPortrait,
          centerInsufficientSlides: true,
          allowTouchMove: true,
          simulateTouch: true,
          grabCursor: true,
          pagination: {
            el: this.$refs.pagination,
          },
          on: {
            slideChangeTransitionEnd: this.slideChangeTransitionEnd,
          },
        })
      );
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setResize);
    destroySwiperInstance(this.swiper);
  },
  methods: {
    getImageByDevice(item) {
      return this.isPortrait ? item.urlMob : item.urlPc;
    },
    getVideoByDevice(item) {
      return this.isPortrait ? item.videoMob : item.videoPc;
    },
    handleSlideClick(item) {
      if (!item || item.type !== "booked") return;
      if (this.swiper && this.swiper.allowClick === false) return;
      const videoPath = this.getVideoByDevice(item);
      if (!videoPath) return;
      this.fullVideoUrl = videoPath;
      this.isShowVideo = true;
    },
    slideChangeTransitionEnd() {
      // placeholder
    },
    setResize() {
      this.isPortrait = isPortraitFun();
      if (this.swiper) {
        this.swiper.params.centeredSlides = !this.isPortrait;
        this.swiper.params.centerInsufficientSlides = true;
        this.swiper.update();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./swiper-common.scss";

.threepage {
  .carousel-container {
    overflow: hidden;
    background: transparent;
  }

  .aw-swiper__slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-shrink: 0;
  }

  @media (min-width: 767px) {
    .aw-swiper__slide:last-child {
      margin-right: 0 !important;
    }
  }
  @media (max-width: 767px) {
    // .aw-swiper__slide:last-child {
    //   margin-right: calc(24 / 750 * 100vw) !important;
    // }
  }

  .aw-swiper__slide--booked {
    cursor: pointer;
  }

  .aw-swiper__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 1;
  }

  ::v-deep .swiper-wrapper {
    align-items: center;
  }
}

@media (max-width: 767px) {
  .threepage {
    position: absolute;
    width: 100%;
    top: calc(375 / 1125 * 100vw);
  }

  .threepage .carousel-container {
    width: calc(700 / 750 * 100vw);
    height: calc(567 / 750 * 100vw);
    margin-left: calc(50 / 750 * 100vw);
    border-radius: 0;
  }

  .threepage .aw-swiper__slide {
    margin-right: calc(30 / 750 * 100vw);
  }

  .threepage .aw-swiper__slide--booked {
    width: calc(436 / 750 * 100vw);
    height: calc(567 / 750 * 100vw);
  }

  .threepage .aw-swiper__slide--coming {
    width: calc(323 / 750 * 100vw);
    height: calc(448 / 750 * 100vw);
  }

  .threepage ::v-deep .swiper-wrapper {
    align-items: center;
  }
}
@media (min-width: 767px) {
  .threepage {
    position: absolute;
    top: calc(234 / 1920 * 100vw);
    left: 0;
    right: 0;
    width: 100%;
  }

  .threepage .carousel-container {
    width: 100%;
    height: calc(600 / 1920 * 100vw);
    border-radius: 0;
  }

  .threepage .aw-swiper__slide {
    margin-right: calc(26 / 1920 * 100vw);
  }

  .threepage .aw-swiper__slide--booked { 
    width: calc(940 / 1920 * 100vw);
    height: calc(567 / 1920 * 100vw);
  }

  .threepage .aw-swiper__slide--coming {
    width: calc(323 / 1920 * 100vw);
    height: calc(448 / 1920 * 100vw);
  }

  .threepage ::v-deep .swiper-wrapper {
    align-items: center;
  }
}
</style>
